import Progress from './progress'

import './style/css'

export default Progress
